var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeck24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "m18.35 9.55-8.51 3.1a2 2 0 0 1-1.88-.26l-2.3-1.68m12.69-1.16 2.3-.84a.5.5 0 0 0 .12-.87l-4.73-3.46a2 2 0 0 0-1.87-.26L3.36 8.07a.5.5 0 0 0-.12.87l2.41 1.77m12.7-1.16 2.46 1.9a.5.5 0 0 1-.14.86l-2.32.85M5.65 10.7l-2.34.95a.5.5 0 0 0-.1.87l2.44 1.79m0 0L7.96 16a2 2 0 0 0 1.88.27l8.5-3.11M5.66 14.32l-2.34.95a.5.5 0 0 0-.1.86l4.75 3.48a2 2 0 0 0 1.88.26l10.83-3.95a.5.5 0 0 0 .14-.87l-2.46-1.9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeck24);
export default __webpack_public_path__ + "static/media/deck_24.b1cdccb0dc4453b6b40ca44c584d6dd9.svg";
export { ForwardRef as ReactComponent };